import endpointUrls from 'global/Constants/endpointUrls';
import { handleApiThen } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { DOMAIN, errorResponse } from 'global/utils/ApiService';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Path, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import Button from '../../common/Button';
import Icon from '../../common/Icon';
import { isBlockActive } from '../../utils/SlateUtilityFunctions';
import usePopup from '../../utils/customHooks/usePopup';
import { insertEmbed } from '../../utils/embed.js';
import './Embed.css';
const Embed = ({ editor, format }) => {
  const urlInputRef = useRef();
  const fileInputRef = useRef();
  const dispatch = useDispatch();

  const [showInput, setShowInput] = usePopup(urlInputRef);
  const [formData, setFormData] = useState({
    url: '',
    alt: '',
  });
  const [localSelection, setSelection] = useState();
  const [_loading, setLoading] = useState(false);

  const handleButtonClick = (e) => {
    e.preventDefault();
    setSelection(editor.selection);
    localSelection && ReactEditor.focus(editor);

    setShowInput((prev) => !prev);
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();

    localSelection && Transforms.select(editor, localSelection);
    localSelection && ReactEditor.focus(editor);

    insertEmbed(editor, { ...formData }, format);
    setShowInput(false);
    setFormData({
      url: '',
      alt: '',
    });
  };
  const openFileInputWindow = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };
  const handleImageUpload = async (e) => {
    if (!e.target.files[0]) return;
    setLoading(true);
    const formData = new FormData();
    formData.append('Image', e.target.files[0]);
    // formData.append('DocumentId', 35);
    // formData.append('Description', '');
    await ApiService.post(endpointUrls.uploadDocumentImage, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) =>
        handleApiThen({
          res,
          dispatch,
          notifFail: true,
          notifSuccess: false,
          onSuccess: (data) => {
            let baseUrl = DOMAIN;
            if (baseUrl[baseUrl.length - 1] === '/') baseUrl = baseUrl.slice(0, baseUrl.length - 1);
            addImageToEditor(`${baseUrl}${data.path}`);
          },
          dataOnly: true,
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
  };
  const addImageToEditor = (imagePath) => {
    localSelection && Transforms.select(editor, localSelection);
    localSelection && ReactEditor.focus(editor);
    const { selection } = editor;
    const image = {
      type: 'image',
      alt: '',
      url: imagePath,
      children: [
        {
          text: '',
        },
      ],
    };

    if (selection) {
      const parentPath = Path.parent(selection.focus.path);
      const nextPath = Path.next(parentPath);
      Transforms.insertNodes(editor, image, {
        at: nextPath,
        select: true,
      });
    } else {
      Transforms.insertNodes(editor, image);
    }
  };
  return (
    <div ref={urlInputRef} className='popup-wrapper !cursor-default relative'>
      <Button active={isBlockActive(editor, format)} style={{ border: showInput ? '1px solid lightgray' : '', borderBottom: 'none' }} format={format} onClick={handleButtonClick}>
        <Icon icon={format} />
      </Button>
      {showInput && (
        <div className='shadow-lg rounded-xl popup'>
          {format === 'image' && (
            <div>
              <input type='file' className='hidden' ref={fileInputRef} onChange={handleImageUpload} accept='image/*' />
              <div
                className='flex justify-center gap-1 py-1 border cursor-pointer rounded-xl border-t-border-color-base hover:border-t-primary-color'
                onClick={openFileInputWindow}>
                <Icon icon='upload' />
                <span>بارگزاری عکس</span>
              </div>
              <hr className='my-2' />
            </div>
          )}
          <form onSubmit={handleFormSubmit} className='flex flex-col gap-1'>
            <span className=''>ورود لینک عکس</span>
            <input type='text' className='px-1 border' placeholder='Enter url' value={formData.url} onChange={(e) => setFormData((prev) => ({ ...prev, url: e.target.value }))} />
            <input type='text' placeholder='Enter alt' className='px-1 border' value={formData.alt} onChange={(e) => setFormData((prev) => ({ ...prev, alt: e.target.value }))} />

            <Button className='rounded-xl text-sm py-1 w-full bg-t-layer-bg-color h-[unset]' type='submit'>
              ذخیره لینک
            </Button>
          </form>
        </div>
      )}
    </div>
  );
};

export default Embed;
